import script from "./archivedTracked.vue?vue&type=script&setup=true&lang=ts"
export * from "./archivedTracked.vue?vue&type=script&setup=true&lang=ts"

import "./archivedTracked.vue?vue&type=style&index=0&id=46d1c40c&lang=scss"

const __exports__ = script;

export default __exports__